<template>
	<div>
		<b-overlay :show="isLoading" rounded="sm">
			<Card body-classes="p-3" class="bg-gradient-secondary">
				<div class="d-flex justify-content-between align-items-center">
					<div class="d-flex align-items-center mr-5">
						<div class="avatar-xl d-flex align-items-center">
							<img
								:src="
									require(`../../../../public/img/icons/cards/${getCardImage()}`)
								"
								alt="Image placeholder"
							/>
						</div>

						<h5 class="surtitle text-white">
							{{ getCardNumber() }}
						</h5>
					</div>
					<div v-if="creditCard">
						<Badge type="secondary"> Active</Badge>
					</div>
				</div>
			</Card>
		</b-overlay>
	</div>
</template>
<script>
import Card from '../../../components/Cards/Card.vue';
import Badge from '../../../components/Badge.vue';
export default {
	props: {
		isLoading: true,
		creditCard: {
			type: Object,
			default: null,
		},
	},
	components: { Card, Badge },
	methods: {
		getCardNumber() {
			if (this.creditCard != null) {
				if (this.creditCard.cardInfo.last4) {
					return `x${this.creditCard.cardInfo.last4}`;
				}
			}
			return 'No Payment Method';
		},
		getCardImage() {
			if (this.creditCard != null) {
				const brand = this.creditCard.cardInfo.brand;
				if (brand == 'visa') {
					return 'visa.png';
				} else if (brand == 'american express') {
					return 'amex.png';
				} else if (brand == 'amex') {
					return 'amex.png';
				} else if (brand == 'mastercard') {
					return 'mastercard.png';
				} else if (brand == 'discover') {
					return 'discover.png';
				}
			}

			return 'unknown.png';
		},
	},
};
</script>
